/**
 * Created by zhouxuwang on 2021/12/10
 */

export default function filterItemSchemaHandle (props) {
  return {
    _type: 'filterItem',
    viewComponentName: 'filter-item-render',
    props: props.name
    // apiName
  }
}

export const filterItemProps = {
  // filter-item的name
  label: {
    type: String,
    default: ''
  }
}
